<template>
    <v-card class="mb-4 mx-2 d-flex flex-column justify-space-between" width="350" height="110"  style="position: relative">
        <v-skeleton-loader v-if="loading" type="card" style="position: absolute; width: 100%; height: 100%"/>
        <div class="px-3 pt-2 text-start body-1 font-weight-thin ">
            Target Resolution
        </div>
        <div class="px-4 caption grey--text ">
            Total productive vs total target for today
        </div>

        <div class="flex-grow-1"></div>
        <template v-if="!loading">
            <v-scroll-x-transition>
                <div class="px-3 pb-1 text-h4 font-weight-light d-flex align-center" v-if="!loading">
                    <v-icon large left>mdi-percent</v-icon>{{ !stats ? '0' : series }}

                </div>
            </v-scroll-x-transition>
            <div style="width: 270px; position: absolute; right: -65px; top: 8px" v-if="!loading" class="pa-2">
                <apex-chart type="radialBar" :options="chartData" :series="[series]"></apex-chart>
            </div>
        </template>
    </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import VueApexCharts from 'vue-apexcharts'
import {hourDisplay, hourDisplayWithoutUnit} from "@/core/codeFunctions";
export default {
    components: {
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: {
                ttt: 0,
                pt: 0
            },
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        async loadProductivity() {
            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/targetResolution')
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        ...mapGetters(['devicesWithAccess', 'devicesWithAccessIds', 'employeesRef', 'labelsRef']),
        labels() {return this.stats.map(stat => stat.key)},
        series() {

            return this.stats && this.stats.ttt === 0 ? 0 : Math.round(this.stats.pt / this.stats.ttt * 100)
        },

        chartData() {
            return {
                plotOptions: {
                    radialBar: {
                        startAngle: -70,
                        endAngle: 70,
                        track: {
                            // show: false,
                            margin: 10,
                            background: '#333',
                            startAngle: -70,
                            endAngle: 70,
                        },
                        hollow: {
                            margin: 0,
                            size: '30%',
                            image: undefined,
                            imageOffsetX: 0,
                            imageOffsetY: 0,
                            position: 'front',
                            dropShadow: {
                                enabled: true,
                                top: 3,
                                left: 0,
                                blur: 4,
                                opacity: 0.24
                            }
                        },
                        dataLabels: {
                            enabled: false,
                            name: {show: false},
                            value: {show: false},
                        }
                    }
                },
                colors: ["var(--v-primary-darken2)"],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'vertical',
                        shadeIntensity: 0.5,
                        gradientToColors: ['var(--v-primary-lighten1)'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
                // stroke: {
                //     lineCap: "round"
                // },
                stroke: {
                    dashArray: 2
                },
                labels: ["Progress"]
            }
        },
    }
}
</script>

<style scoped>

</style>